import React, { ReactNode } from 'react';
import cx from 'clsx';

import { HelperTooltip } from 'components';

import style from './index.module.css';

interface SelectItem {
  mode: string;
  label: ReactNode;
  disabledTip?: string;
  disabled?: boolean;
}

type Props<T> = {
  value: string;
  options: T[];
  onChange: (mode: string) => void;
  bottomBorder?: boolean;
  className?: string;
  itemClassName?: string;
  itemSelectedClassName?: string;
  renderLabel?: (item: T) => ReactNode;
};

export const SelectTab = <T extends SelectItem>(props: Props<T>) => {
  return (
    <div className={cx(style.tab, props.bottomBorder && style.border, props.className)}>
      {props.options.map(e => {
        const disabledTip = e.disabledTip || e.disabled;

        return (
          <div
            className={cx(
              style.tabItem,
              props.value === e.mode && style.selected,
              props.value === e.mode && props.itemSelectedClassName,
              disabledTip && style.disabled,
              props.itemClassName,
            )}
            onClick={disabledTip ? undefined : () => props.onChange(e.mode)}
            key={e.mode}>
            <HelperTooltip title={disabledTip} disable={!disabledTip}>
              {props.renderLabel ? props.renderLabel(e) : e.label}
            </HelperTooltip>
          </div>
        );
      })}
    </div>
  );
};
